// extracted by mini-css-extract-plugin
export default {"errorScreen":"ErrorScreen_errorScreen__SWXT3","logo":"ErrorScreen_logo__HV5Ab","title":"ErrorScreen_title__HtXeg","pg":"ErrorScreen_pg__qdEPO","action":"ErrorScreen_action__wSSGN"};